import * as gridActions from '../actions/grid.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface GridState {
    updateSuccess?: boolean;
    updateFailed?: boolean;
    addSuccess?: boolean;
    addFailed?: boolean;
    deleteSuccess?: boolean;
    deleteFailed?: boolean;
}

const initialState = {
    updateSuccess: null,
    updateFailed: null,
    addSuccess: null,
    addFailed: null,
    deleteSuccess: null,
    deleteFailed: null
};

export const gridReducer = (state = initialState, action) => {
    switch (action.type) {
        case gridActions.ADD_GRID_SUCCESS:
            return {
                ...state,
                updateSuccess: true,
                updateFailed: false
            };

        case gridActions.ADD_GRID_FAIL:
            return {
                ...state,
                updateSuccess: false,
                updateFailed: true,
            };
        case gridActions.DELETE_GRID_SUCCESS:
            return {
                ...state,
                deleteSuccess: true,
                deleteFailed: false
            };
        case gridActions.DELETE_GRID_FAIL:
            return {
                ...state,
                deleteSuccess: false,
                deleteFailed: true
            };
        case gridActions.UPDATE_GRID_SUCCESS:
            return {
                ...state,
                updateSuccess: true,
                updateFailed: false
            };
        case gridActions.UPDATE_GRID_FAIL:
            return {
                ...state,
                updateSuccess: false,
                updateFailed: true
            };
        default:
            return state;
    }
};

export const getGridState = createFeatureSelector<GridState>('gridReducer');
export const getGridAddFail = (state: GridState) => state.addFailed;
export const getGridDeleteFail = (state) => state.deleteFailed;
export const getGridUpdateFail = (state) => state.updateFailed;
